"use client";

import { useEffect } from "react";

/**
 * Client component that listens for privacy policy button clicks
 * and triggers the OneTrust privacy settings modal.
 *
 * This component listens for the "privacyButtonClick" custom event
 * dispatched from the Footer component and opens the OneTrust
 * cookie consent preferences dialog.
 */
export function PrivacyPolicyListener() {
  useEffect(() => {
    const handlePrivacyButtonClick = () => {
      // Open OneTrust privacy settings modal
      if (typeof window !== "undefined" && window.Optanon) {
        window.Optanon.ToggleInfoDisplay();
      }
    };

    window.addEventListener("privacyButtonClick", handlePrivacyButtonClick);

    return () => {
      window.removeEventListener(
        "privacyButtonClick",
        handlePrivacyButtonClick,
      );
    };
  }, []);

  // This is a client island - no UI rendered
  return null;
}
